import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  getContactUsAsync,
  updateContactUsLeadTypeAsync,
  contactUsAction,
} from "../redux";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../../_metronic/_partials/controls";

const ViewContactUs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { ContactList } = useSelector((state) => state.contactUs);
  const { id } = useParams();
  let { cdnURL } = useSelector((state) => state.environnment.environmentLists);
  const [leadType, setLeadType] = useState(null);
  const [selectedLeadType, setSelectedLeadType] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [justSaved, setJustSaved] = useState(false);

  useEffect(() => {
    dispatch(getContactUsAsync(id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (ContactList && ContactList._id) {
      // Normalize leadType to lowercase to match radio button values
      const currentLeadType = ContactList.leadType
        ? ContactList.leadType.toLowerCase()
        : null;

      // If we just saved, preserve the saved value unless server returns a different non-null value
      if (justSaved) {
        if (currentLeadType && currentLeadType !== selectedLeadType) {
          // Server returned a different value, use it (normalized to lowercase)
          setLeadType(currentLeadType);
          setSelectedLeadType(currentLeadType);
          setJustSaved(false);
        } else if (!currentLeadType && selectedLeadType) {
          // Server didn't return leadType, keep our saved value
          // Don't clear it
          setJustSaved(false);
        } else if (currentLeadType === selectedLeadType) {
          // Server returned the same value we saved, ensure it's set
          setLeadType(currentLeadType);
          setSelectedLeadType(currentLeadType);
          setJustSaved(false);
        } else {
          setJustSaved(false);
        }
      } else {
        // Normal sync: only update if no unsaved changes or if we don't have a selection yet
        if (selectedLeadType === leadType || !selectedLeadType) {
          setLeadType(currentLeadType);
          setSelectedLeadType(currentLeadType);
        }
      }
    }
  }, [ContactList, selectedLeadType, leadType, justSaved]);

  const redirectBack = () => {
    // Reset leadType filter to show all data
    dispatch(contactUsAction.setLeadType("all"));
    history.push("/contact-us");
  };

  const leadTypeOptions = [
    { value: "genuine", label: "Genuine", color: "#28a745" },
    { value: "promotional", label: "Promotional", color: "#007bff" },
    { value: "spam", label: "Spam", color: "#dc3545" },
  ];

  const getLeadTypeColor = (type) => {
    const option = leadTypeOptions.find((opt) => opt.value === type);
    return option ? option.color : "#6c757d";
  };

  const handleLeadTypeChange = (e) => {
    const newLeadType = e.target.value;
    setSelectedLeadType(newLeadType);
  };

  const handleSaveLeadType = async () => {
    if (!id) {
      return;
    }

    if (selectedLeadType === leadType) {
      return;
    }

    setIsSaving(true);
    const previousLeadType = leadType; // Store previous value for error handling
    const savedLeadType = selectedLeadType; // Store the value we're saving

    try {
      const savedData = await dispatch(
        updateContactUsLeadTypeAsync(id, selectedLeadType),
      );

      // The updateContactUsLeadTypeAsync already updates ContactList via getContactSuccess
      // Use the leadType from the response if available, normalize to lowercase
      const updatedLeadType =
        savedData && savedData.leadType
          ? savedData.leadType.toLowerCase()
          : savedLeadType;

      // Update state with the saved value immediately (normalized to lowercase)
      setLeadType(updatedLeadType);
      setSelectedLeadType(updatedLeadType);
      setJustSaved(true); // Mark that we just saved

      // Refresh the data from server to ensure we have the latest data
      // The useEffect will handle syncing while preserving the saved value
      await dispatch(getContactUsAsync(id));
    } catch (error) {
      // Error is already handled in the API function
      console.error("Error saving lead type:", error);
      // Revert to previous value on error
      setSelectedLeadType(previousLeadType);
      setLeadType(previousLeadType);
      setJustSaved(false);
    } finally {
      setIsSaving(false);
    }
  };

  const hasUnsavedChanges = selectedLeadType !== leadType;

  return (
    <>
      <Formik enableReinitialize initialValues={ContactList}>
        {({ values }) => (
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card>
                <CardHeader title="View Contact Us"></CardHeader>
                <CardBody>
                  <Form>
                    <div className="form-group">
                      <label className="form-label"> Name</label>
                      <input
                        className="form-control re_inputRouded"
                        placeholder="Name"
                        type="text"
                        disabled={true}
                        name="name"
                        value={values.name}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label"> Email</label>
                      <Link
                        href="#"
                        onClick={(e) => {
                          window.location = `mailto:${values.email}`;
                          e.preventDefault();
                        }}
                      >
                        <input
                          className="form-control re_inputRouded"
                          style={{
                            cursor: "pointer",
                            color: "blue",
                            backgroundColor: "#F3F6F9",
                            opacity: 1,
                          }}
                          placeholder="Email"
                          type="text"
                          disabled={true}
                          name="emails"
                          value={values.email}
                        />
                      </Link>
                    </div>
                    <div className="form-group">
                      <label className="form-label"> Contact No.</label>
                      <Link
                        href="#"
                        onClick={(e) => {
                          window.location = `tel:${values.countryCode}${values.contactNumber}`;
                          e.preventDefault();
                        }}
                      >
                        <input
                          className="form-control re_inputRouded"
                          style={{ cursor: "pointer", color: "blue" }}
                          placeholder="Contact Number"
                          type="text"
                          disabled={true}
                          name="contactNumber"
                          value={`${values.contactNumber}`}
                        />
                      </Link>
                    </div>
                    <div className="form-group">
                      <label className="form-label"> Country From IP</label>
                      <input
                        className="form-control re_inputRouded"
                        style={{ cursor: "pointer", color: "blue" }}
                        placeholder="Country From IP"
                        type="text"
                        disabled={true}
                        name="countryName"
                        value={values.countryName}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Country From Phone Ext
                      </label>
                      <input
                        className="form-control re_inputRouded"
                        placeholder="Country From Phone Ext"
                        type="text"
                        disabled={true}
                        name="countryNameFromCountryCode"
                        value={values.countryNameFromCountryCode}
                      />
                    </div>
                    {/* <div className="form-group">
                      <label className="form-label"> Skype Id</label>
                      <Link
                        href="#"
                        onClick={(e) => {
                          window.location = `skype:${values.skypeId}`;
                          e.preventDefault();
                        }}
                      >
                        <input
                          className="form-control re_inputRouded"
                          style={{ cursor: "pointer", color: "blue" }}
                          placeholder="Skype Id"
                          type="text"
                          disabled={true}
                          name="skypeId"
                          value={values.skypeId}
                        />
                      </Link>
                    </div> */}
                    <div className="form-group">
                      <label className="form-label">Project Requirements</label>
                      <textarea
                        className="form-control re_inputRouded"
                        rows={5}
                        placeholder="Project Requirement"
                        type="text"
                        disabled={true}
                        name="pro_requirement"
                        value={values.pro_requirements}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label"> Page Name</label>
                      <input
                        className="form-control re_inputRouded"
                        placeholder="PageName"
                        type="text"
                        disabled={true}
                        name="pagename"
                        value={values.pageName}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label"> File</label>
                      <Link
                        href="#"
                        onClick={(e) => {
                          if (values.uploadFile) {
                            window.open(
                              `${cdnURL}${values.uploadFile}`,
                              "_blank",
                            );
                            e.preventDefault();
                          }
                        }}
                      >
                        <input
                          className="form-control re_inputRouded"
                          style={{ cursor: "pointer", color: "blue" }}
                          placeholder="uploadFile"
                          type="text"
                          name="uploadFile"
                          value={values.uploadFile}
                        />
                      </Link>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Lead Type</label>
                      <div className="d-flex align-items-center flex-wrap">
                        <div style={{ flex: 1, marginRight: "10px" }}>
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "20px" }}
                          >
                            {leadTypeOptions.map((option) => (
                              <label
                                key={option.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: isSaving ? "not-allowed" : "pointer",
                                  opacity: isSaving ? 0.6 : 1,
                                  marginBottom: 0,
                                }}
                              >
                                <input
                                  type="radio"
                                  name="leadType"
                                  value={option.value}
                                  checked={selectedLeadType === option.value}
                                  onChange={handleLeadTypeChange}
                                  disabled={isSaving}
                                  style={{
                                    marginRight: "8px",
                                    width: "18px",
                                    height: "18px",
                                    cursor: isSaving
                                      ? "not-allowed"
                                      : "pointer",
                                    accentColor: option.color,
                                  }}
                                />
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight:
                                      selectedLeadType === option.value
                                        ? "bold"
                                        : "normal",
                                    color:
                                      selectedLeadType === option.value
                                        ? option.color
                                        : "#333",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      backgroundColor: option.color,
                                      marginRight: "8px",
                                      display: "inline-block",
                                    }}
                                  />
                                  {option.label}
                                </span>
                              </label>
                            ))}
                          </div>
                          {selectedLeadType && (
                            <div
                              style={{
                                marginTop: "10px",
                                fontSize: "14px",
                                color: "#666",
                              }}
                            >
                              Selected:{" "}
                              <span
                                style={{
                                  color: getLeadTypeColor(selectedLeadType),
                                  fontWeight: "bold",
                                }}
                              >
                                {
                                  leadTypeOptions.find(
                                    (opt) => opt.value === selectedLeadType,
                                  )?.label
                                }
                              </span>
                            </div>
                          )}
                        </div>
                        <Button
                          variant="primary"
                          size="lg"
                          onClick={handleSaveLeadType}
                          disabled={
                            !hasUnsavedChanges || isSaving || !selectedLeadType
                          }
                          style={{ minWidth: "100px" }}
                        >
                          {isSaving ? "Saving..." : "Save"}
                        </Button>
                      </div>
                    </div>
                    <div className="text-center">
                      <Button
                        variant="blue"
                        className="px-5 defpddng "
                        size="lg"
                        onClick={redirectBack}
                      >
                        Close
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Formik>
    </>
  );
};

export default ViewContactUs;
